module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-2-p-6c6f9dc44c0679ed37c61db17099af01.gif";